module.exports = __webpack_public_path__ + "img/body-icon.196a7375.png";